export const formatBillingDate = (isoDate: string, locale: string): string =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  });
